import Vue from 'vue'
import VueI18n from 'vue-i18n'
import vnMessage from './vn'
import enMessage from './en'
import idMessage from './id'
import thMessage from './th'
import hkMessage from './hk'
import twMessage from './tw'
import inMessage from './in'
import krMessage from './kr'

import { APP_LANG_DEFAULT, APP_LANG_VN, APP_LANG_ID, APP_LANG_TH, APP_LANG_HK, APP_LANG_TW, APP_LANG_IN, APP_LANG_KR } from "@constants"

Vue.use(VueI18n)

export const LANGUAGES = {
   [APP_LANG_DEFAULT]: 'en',
   [APP_LANG_VN]: 'vn',
   [APP_LANG_ID]: 'id',
   [APP_LANG_TH]: 'th',
   [APP_LANG_HK]: 'hk',
   [APP_LANG_TW]: 'tw',
   [APP_LANG_IN]: 'in',
   [APP_LANG_KR]: 'kr',
}

const messages = {
  vn: vnMessage,
  en: enMessage,
  id: idMessage,
  th: thMessage,
  hk: hkMessage,
  tw: twMessage,
  in: inMessage,
  kr: krMessage,
}

const i18n = new VueI18n({
  messages,
  fallbackLocale: LANGUAGES[APP_LANG_DEFAULT],
  silentTranslationWarn: true,
})

export default i18n
